module.exports = __webpack_public_path__ + "static/media/multiflight.9f029423.png";